import { AuthContextProps } from 'services/Authentication/context/context'
import { ExternalAuthState } from '../ExternalAuthState'

export const ExternalAuthMounter = (props: AuthContextProps) => {
	ExternalAuthState.setFunctions(props)
	return null
}
